module.exports = __webpack_public_path__ + "img/Busy_Corner@3x.30c62145.webp";